import { useQuery } from '@tanstack/react-query';
import { getSumSubCredentials } from '../requests';
import { useSessionStore } from '@/entities/session';

const useVerificationServiceCredentials = () => {
  const { session } = useSessionStore();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['verificationServiceCredentials', session?.userId],
    queryFn: getSumSubCredentials,
    enabled: !!session?.userId,
  });

  return {
    verificationServiceCredentials: data,
    isVerificationServiceCredentialsLoading: isLoading,
    verificationServiceCredentialsError: error,
    refetchVerificationServiceCredentials: refetch,
  };
};

export { useVerificationServiceCredentials };
